import { render, staticRenderFns } from "./CustomerSatisfactionPercentageWidget.vue?vue&type=template&id=b763470a&scoped=true&"
import script from "./CustomerSatisfactionPercentageWidget.vue?vue&type=script&lang=js&"
export * from "./CustomerSatisfactionPercentageWidget.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSatisfactionPercentageWidget.vue?vue&type=style&index=0&id=b763470a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b763470a",
  null
  
)

export default component.exports